export const offer = {
  firstOrder: '10% für dich bei der 1. Bestellung',
};

export const ie = {
  disclaimer: 'Ihr Browser wird leider nicht unterstützt.',
  recommendation: 'Bitte verwenden Sie stattdessen Google Chrome, Mozilla Firefox oder Microsoft Edge.',
};

export const cms = {
  dynPageError: 'Dieser dynamische Inhalt ist aktuell leider nicht verfügbar.',
  formThankYou: 'Danke für Ihre Anfrage!',
  recaptchaError: 'Bitte bestätigen Sie, dass Sie keine Maschine sind.',
  contact: {
    phonePrefix: 'T:',
    faxPrefix: 'F:',
  },
  event: {
    today: 'Heute!',
    thisWeek: 'Diese Woche!',
    nextWeek: 'Kommende Woche',
  },
};

export const cookie = {
  infoText: 'Um Ihr Online Einkaufserlebnis bestmöglich auf Sie abzustimmen, verwenden wir auf unserer Seite ' +
    'Cookies. Mit Klick auf den Button oder durch Fortsetzung der Navigation auf dieser Webseite stimmen Sie der ' +
    'Verwendung der Cookies zu.',
};
